<template>
  <vx-card no-shadow>
     <vx-form class="md:w-1/2" layout="v" label-align="top" v-slot="{invalid, handleSubmit}">
      <form-item label="企业名称" rules="required" help="企业名全称，公开后显示在溯源页面">
        <vs-input class="w-full" placeholder="请输入企业名称" v-model="form.name" />
      </form-item>
      <form-item label="行业类型" help="行业类型，公开后显示在溯源页面，如果不在列表内可输入">
        <vs-input class="w-full" placeholder="" v-model="form.industry" />
      </form-item>
      <form-item label="企业官网" help="公开后显示在溯源页面上，并直接跳转">
        <vs-input class="w-full" placeholder="请输入网址" v-model="form.introSite" />
      </form-item>
      <form-item v-if="$s.auth.user.roleID != 6" required label="统一社会信用代码" help="我们会严格保密您的统一社会信用代码，只用于开发票">
        <vs-input class="w-full" v-model="form.societyCode" />
      </form-item>
      <form-item label="网上店铺" help="公开后显示在溯源页面上，并直接跳转">
        <vs-input class="w-full" placeholder="请输入网址" v-model="form.shopSite" />
      </form-item>
      <form-item label="实体店地址" help="填写您的店面地址信息">
        <vs-input class="w-full" placeholder="请输入详细地址" v-model="form.shopAddr" />
      </form-item>
      <form-item label="扩展信息" help="扩展信息会显示到溯源模板中，不填将不会显示，您可以填写公司简介，填写联系方式，或者其他信息，支持文字、图片形式">
        <editor class="w-full" v-model="form.extInfo" />
      </form-item>
      <form-item required class="mt-5" label="企业Logo" :help="logoHelp">
        <upload
          fileName="file"
          v-model="form.logo"
          data-vv-name="installer"
          automatic
          text="上传Logo"
          accept=".jpg,.png"
          action="/admin/v1/file/upload"
          :single-upload="true"
          :limit="1"
        />
      </form-item>
      <form-item class="mt-5" label="微信公众号" help="公开后显示在溯源页面上，使用户直接关注您的微信公众号">
        <upload
          fileName="file"
          v-model="form.wxpubImg"
          data-vv-name="installer"
          automatic
          text="上传微信公众号二维码"
          accept=".jpg,.png"
          action="/admin/v1/file/upload"
          :single-upload="true"
          :limit="1"
        />
      </form-item>
       <form-item label="隐私设置" help="只有打勾的信息才会在溯源页面显示，未打勾的不会显示" label-align="none">
         <ul class="centerx">
           <li><vs-checkbox v-model="form.publicFields" vs-value="name">企业名称</vs-checkbox></li>
           <li><vs-checkbox v-model="form.publicFields" vs-value="industry">行业类型</vs-checkbox></li>
           <li><vs-checkbox v-model="form.publicFields" vs-value="introSite">企业宣传网址</vs-checkbox></li>
           <li><vs-checkbox v-model="form.publicFields" vs-value="shopSite">网上店铺</vs-checkbox></li>
           <li><vs-checkbox v-model="form.publicFields" vs-value="shopAddr">实体店地址</vs-checkbox></li>
           <li><vs-checkbox v-model="form.publicFields" vs-value="logo">企业Logo</vs-checkbox></li>
           <li><vs-checkbox v-model="form.publicFields" vs-value="wxpubImg">微信公众号</vs-checkbox></li>
         </ul>
       </form-item>
      <form-item>
        <vs-button v-if="nextStep" :disabled="invalid" class="mr-3 mb-2" @click="handleSubmit(submitFormAndStep)">下一步</vs-button>
        <vs-button v-else :disabled="invalid" class="mr-3 mb-2" @click="handleSubmit(submitForm)">保存设置</vs-button>
      </form-item>
     </vx-form>
  </vx-card>
</template>
<script>
import Editor from '@/components/editor'
export default {
  props: {
    nextStep: Function,
  },
  components: {
    Editor,
  },
  data() {
    return {
      form: {
        publicFields: [],
      }
    }
  },
  computed: {
    logoHelp() {
      const roleID = this.$s.auth.user.roleID
      const userText = "公开后显示在溯源页面中，图片格式支持 .jpg,.png"
      const channelText = "您的角色是渠道商，您和您的客户登录后，在后台右上角将会显示您在此处上传的 Logo，图片格式支持 .jpg,.png"
      const defChannelText = "您的角色是默认渠道商，您和普通用户登录后台，将显示您在此处上传的 Logo ，图片格式支持 .jpg,.png"
      const adminText = "您是系统管理员，渠道商将会默认显示您设置的Logo，直到渠道商上传自己的 Logo，图片格式支持 .jpg,.png"
      const text = {
        1: adminText,
        2: adminText,
        3: channelText,
        4: defChannelText,
        5: userText,
        6: userText,
      }
      return text[roleID]
    }
  },
  async mounted() {
    const company = await this.$s.user.getCompany(true)
    this.form = {
      ...company,
      publicFields: company.publicFields || [],
    }
  },
  methods: {
    async submitForm() {
      const data = {
        ...this.form,
      }
      await this.$s.user.updateCompany(data)
      this.$notify({
        title: "成功更新公司信息"
      })
      this.$s.user.getCompany(true)
      this.$s.fetchSite()
    },
    async submitFormAndStep() {
      await this.submitForm()
      this.nextStep()
    }
  }
}
</script>